export const getQuestionIndex = ({ questionIndex }) => parseInt(questionIndex, 10);

export const getQueryFrom = location => location.query.from;

export const getMeasureType = pathname => pathname.split('/')[3];
